// import { useState } from 'react'

export default function Founder() {
  // const [expanded, setExpanded] = useState(false)
  return (
    <section className="founder" id="founder">
      <div className="founder-inner">
        <div className="founder-header reveal">
          <img src="/static/tiger-picture.png" alt="Dr. Tiger Bawa" className="founder-photo" />
          <div className="section-label">A letter from our founder</div>
          <h2 className="section-title">
            Hi. I&rsquo;m <em>Tiger.</em>
          </h2>
        </div>
        <div className="founder-letter">
          <p className="reveal">
            I&rsquo;m an OB/GYN and Reproductive Endocrinology &amp; Infertility fellow at the Cleveland Clinic. I am the first doctor in my family. So, as you can imagine, it has been a roller coaster of a ride to understand how to navigate this field. For starters, I thought I was going to be a cardiologist.
          </p>
          <p className="reveal reveal-delay-1">
            But medicine has a way of redirecting you toward what you were always supposed to do. For me, that redirect came from my own family.
          </p>

          <div className="founder-letter-expanded open">
            <p>
              My sister has had painful periods her entire life and has yet to see an OB/GYN. My mother and father struggled with infertility that went completely untreated. And somehow, miraculously, I exist. Two of my aunts have breast cancer. One has ovarian cancer. One has thyroid cancer. And my entire family&rsquo;s response to all of it?
            </p>
            <p>
              Thankfully my aunts received treatment &hellip; but the rest of the family? Declined genetic testing (which is wrong, by the way). They barely go to their annual exams. Any complaint is held close to the chest. Appear strong. Don&rsquo;t let anyone see the weakness.
            </p>
            <p>
              This is the immigrant household I grew up in. And I say that with love because I understand exactly why. When you come to a new country, vulnerability feels dangerous. What will people think? What does it say about us? <strong>So, you stay quiet. You manage. You push through.</strong>
            </p>
            <p>The problem is &hellip; your body doesn&rsquo;t care about appearances.</p>
            <p>
              I watched my sister push through painful periods for years, calling them &ldquo;just cramps.&rdquo; I watched my fianc&eacute;e, a brilliant, informed woman, pour herself into her residency and her patients, putting her own health last, rarely seeing her own doctor. And I keep sitting in my clinic watching patient after patient tell me stories filled with dismissal, distrust, anxiety, and sadness after feeling so unheard. Years of symptoms. Years of being dismissed. Years of being told it was normal, it was stress, it was just part of being a woman.
            </p>
            <p><strong>It wasn&rsquo;t normal. It was never normal.</strong></p>
            <p>
              Here&rsquo;s what I&rsquo;ve learned: we actually understand a lot about these conditions. Endometriosis, PMOS, adenomyosis, hormonal dysfunction &hellip; the science exists. The treatments exist. The answers are closer than most women have been told. The gap isn&rsquo;t knowledge. <strong>The gap is awareness.</strong> Women don&rsquo;t know what they&rsquo;re experiencing has a name. They don&rsquo;t know it can be treated. They&rsquo;ve been told for so long that their pain is ordinary that they&rsquo;ve stopped questioning it.
            </p>
            <p>
              I became an OB/GYN because of my family. I became a fertility specialist because of my patients. I built Pelvia because of both.
            </p>
            <p>
              You may open this app today and have nothing to log. That&rsquo;s okay. You may open it in six months when something changes, and you can&rsquo;t explain why. Log it. You may open it in two years and hand your doctor three months of documented patterns that finally lead to an answer you&rsquo;ve been waiting years for. That&rsquo;s the whole point.
            </p>
            <p>
              <strong>Ninety-nine percent of the time the symptoms you feel, but can&rsquo;t explain, are connected to something real.</strong> Something treatable. Something that has a name and a path forward.
            </p>
            <p>
              I am standing for you. For your symptoms. For every painful period that was dismissed, every mood change that was minimized, every bloated morning that was called nothing.
            </p>
            <p>Your health belongs in your hands.</p>
            <p>That is my promise.</p>
          </div>

          {/* <button
            type="button"
            className="founder-read-more"
            onClick={() => setExpanded((e) => !e)}
          >
            {expanded ? 'Read less' : 'Read more'}
          </button> */}

          <div className="founder-signoff reveal">
            <div className="founder-signoff-promise">Your Pain is Real.</div>
            <div className="founder-signoff-role">Pelvia Founder,</div>
            <div className="founder-signoff-name">Tiger Bawa, MD</div>
            <div className="founder-signoff-title">OB/GYN &middot; REI Fellow, Cleveland Clinic</div>
          </div>
        </div>
      </div>
    </section>
  )
}
